export interface TeacherInfo {
  code: string;
  nickname: string | null;
  firstName: string;
  lastName: string | null;
}

export interface StudentInfo {
  code: string;
  first_name: string;
  last_name: string | null;
  nickname: string | null;
  hours: number | null;
}

export interface Schedule {
  weekday: number;
  start_time: string;
  end_time: string;
  room_name: string;
}

export interface CreateTemplateFormData {
  // Step 1
  teacher_code: string;
  teacher_info: TeacherInfo | null;
  students: StudentInfo[];
  
  // Step 2
  schedules: Schedule[];
  start_date: string | null;
  
  // Step 3
  subject: string;
  education_level: string;
  course_type: 'REGULAR' | 'INTER';
  class_type: 'PREMIER' | 'PRIVATE';
  language: 'THAI' | 'ENGLISH';
  
  // Step 4
  location: string;
  is_special_class: boolean;
  fixed_cost: number | null;
  note: string;
  status: 'NORMAL' | 'PAUSED';
}

export const initialFormData: CreateTemplateFormData = {
  teacher_code: '',
  teacher_info: null,
  students: [],
  schedules: [{ weekday: 1, start_time: '09:00', end_time: '11:00', room_name: '' }],
  start_date: null,
  subject: '',
  education_level: 'ม.1',
  course_type: 'REGULAR',
  class_type: 'PREMIER',
  language: 'THAI',
  location: '',
  is_special_class: false,
  fixed_cost: null,
  note: '',
  status: 'NORMAL',
};
